import { MAINTAIN_WEIGHT, LOSE_WEIGHT, GAIN_WEIGHT } from 'js/goals'

export default {
  [MAINTAIN_WEIGHT]: 'Maintain',
  [LOSE_WEIGHT]: 'Lose',
  [GAIN_WEIGHT]: 'Gain',
}
